import { Link } from 'react-router-dom';
import { featuredVideos } from '@/mocks/videos';

export default function FeaturedSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              精选推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-2">编辑团队精心挑选的高分佳作</p>
          </div>
          <Link
            to="/category/all"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap flex items-center gap-1 cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>

        <div data-product-shop className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {featuredVideos.map((video) => (
            <Link
              key={video.id}
              to={`/article/${video.id}`}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all cursor-pointer"
            >
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src={video.thumbnail}
                  alt={video.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3 bg-background-950/75 backdrop-blur-sm text-background-50 text-xs px-2 py-0.5 rounded-md">
                  {video.resolution}
                </div>
                <div className="absolute bottom-3 right-3 bg-background-950/75 backdrop-blur-sm text-background-50 text-xs px-2 py-0.5 rounded-md">
                  {video.duration}
                </div>
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all flex items-center justify-center">
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-500/90 opacity-0 group-hover:opacity-100 transition-all transform scale-75 group-hover:scale-100">
                    <i className="ri-play-fill text-background-50 text-2xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading font-semibold text-foreground-900 text-sm md:text-base mb-2 line-clamp-1 group-hover:text-primary-500 transition-colors">
                  {video.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2 mb-3">{video.description}</p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-400">{video.views} 次观看</span>
                  <span className="text-xs bg-secondary-100 text-secondary-700 px-2 py-0.5 rounded-full">{video.category}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}